import React from 'react';

interface DebugPanelProps {
  onClose: () => void;
}

const DebugPanel: React.FC<DebugPanelProps> = ({ onClose }) => {
  return (
    <div className="fixed bottom-0 right-0 w-96 h-96 bg-gray-900 text-white p-4 overflow-auto shadow-lg rounded-tl-lg">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">Debug Console</h2>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-white transition-colors"
        >
          Close
        </button>
      </div>
      
      <div className="space-y-4">
        <div className="border-b border-gray-700 pb-2">
          <h3 className="text-sm font-medium text-gray-400">Environment</h3>
          <pre className="text-xs mt-1">
            {JSON.stringify({
              nodeEnv: import.meta.env.MODE,
              baseUrl: import.meta.env.BASE_URL,
              timestamp: new Date().toISOString(),
            }, null, 2)}
          </pre>
        </div>

        <div className="border-b border-gray-700 pb-2">
          <h3 className="text-sm font-medium text-gray-400">Window Info</h3>
          <pre className="text-xs mt-1">
            {JSON.stringify({
              innerWidth: window.innerWidth,
              innerHeight: window.innerHeight,
              devicePixelRatio: window.devicePixelRatio,
              userAgent: window.navigator.userAgent,
            }, null, 2)}
          </pre>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-400">Performance</h3>
          <pre className="text-xs mt-1">
            {JSON.stringify({
              memory: (performance as any).memory ? {
                jsHeapSizeLimit: Math.round((performance as any).memory.jsHeapSizeLimit / 1048576),
                totalJSHeapSize: Math.round((performance as any).memory.totalJSHeapSize / 1048576),
                usedJSHeapSize: Math.round((performance as any).memory.usedJSHeapSize / 1048576),
              } : 'Not available',
              navigation: performance.getEntriesByType('navigation')[0],
            }, null, 2)}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default DebugPanel;